import AsyncAutocompleteInput, {
  type AsyncAutocompleteInputProps,
} from '@/components/form/AsyncAutocompleteInput'
import type { Customer } from '@/lib/services/customers/customers.types'
import type { LucideIcon } from 'lucide-react'
import { Typography } from '@/components/ui/typography'
import { formatPhone } from '@/hooks/use-phone-formatter'
import { formatCustomerAddressLine } from '@/lib/services/customers/customers.address'
import { Mail, MapPin, Phone } from 'lucide-react'

export function CustomerSearchInput<TOption>(props: AsyncAutocompleteInputProps<TOption>) {
  return <AsyncAutocompleteInput dropdownInPortal containWheel {...props} />
}

export function renderCustomerOption(
  option: Pick<Customer, 'name' | 'phone' | 'email' | 'physical_address'>
) {
  const addressLine = formatCustomerAddressLine(option.physical_address)
  const details: [LucideIcon, string | null | undefined][] = [
    [Phone, option.phone && formatPhone(option.phone)],
    [Mail, option.email],
    [MapPin, addressLine],
  ]

  return (
    <div className="flex min-w-0 flex-col gap-1.5 py-1">
      <Typography variant="bodySmall" weight="semibold">
        {option.name}
      </Typography>
      {details
        .filter(([, value]) => value)
        .map(([Icon, value]) => (
          <div key={value} className="flex min-w-0 items-center gap-2">
            <Icon className="size-3.5 shrink-0" />
            <Typography variant="supporting" className="min-w-0 break-words">
              {value}
            </Typography>
          </div>
        ))}
    </div>
  )
}
